import Config from "Config";
import { getApiClient } from "@ROM/App/ApiClient";

const API_URL = Config.API_FULL_URL;

const urls = {
  collection() {
    return "/addresses";
  },

  resource(id) {
    return `/addresses/${id}`;
  },

  countries() {
    return `/addresses/countries`;
  },
};

export default {
  list(attributes = {}) {
    const client = getApiClient(API_URL);
    return client.get(urls.collection(), {
      params: {
        ...attributes,
      },
    });
  },

  find(id) {
    const client = getApiClient(API_URL);
    return client.get(urls.resource(id));
  },

  create(attributes) {
    const client = getApiClient(API_URL);
    return client.post(urls.collection(), attributes);
  },

  update(id, attributes) {
    const client = getApiClient(API_URL);
    return client.patch(urls.resource(id), attributes);
  },

  destroy(id) {
    const client = getApiClient(API_URL);
    return client.delete(urls.resource(id));
  },

  fetchCountries() {
    const client = getApiClient(API_URL);
    return client.get(urls.countries());
  },
};
